import React, { Component } from "react";
import PropTypes from "prop-types";
import Util from "../../../common/util";

class Experience extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDescriptionShow: false
    };
  }

  handleDescriptionShow = () => {
    this.setState(prevState => (
      { isDescriptionShow: !prevState.isDescriptionShow }
    ));
  };

  render () {
    const { isDescriptionShow } = this.state;
    const { experience } = this.props;

    return (
      <React.Fragment>
        {experience.title && <p className='role'>{experience.title}</p>}
        {experience.description && (
          <div className='career-description' onClick={this.handleDescriptionShow} onKeyDown={this.handleDescriptionShow} role='presentation'>
            <p className={isDescriptionShow ? "description-show" : "description-omit"}>{Util.newLineToBrTag(experience.description)}</p>
          </div>
        )}
        <p className='date'>
          <span className='start-date'>
            {experience.start_date}
          </span>

          {(experience.current || experience.end_date) && (
            <span className='end-date'>
              {experience.current ? "現在" : experience.end_date }
            </span>
          )}
        </p>
      </React.Fragment>
    );
  }
}

Experience.propTypes = {
  experience: PropTypes.shape({
    title: PropTypes.string,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string
  }).isRequired
};

export default Experience;
